import { Comments, Home, NewTask, TaskList, ViewFile } from "../pages";

import ProfilePage from "../pages/Profile";

export default function route() {
  return [
    {
      path: "/home",
      name: "Home",
      key: "/home",
      private: true,
      element: <Home />,
    },
    {
      path: "/comments/:id",
      name: "Chat",
      key: "/comments/:id",
      private: true,
      element: <Comments />,
    },
    {
      path: "/task",
      name: "New Task",
      key: "/task",
      private: true,
      element: <NewTask />,
    },
    {
      path: "/profile",
      name: "Profile",
      key: "/profile",
      private: true,
      element: <ProfilePage />,
    },
    {
      path: "/task-list",
      name: "Task List",
      key: "/task-list",
      private: true,
      element: <TaskList />,
    },
    {
      path: "/view-file",
      name: "View File",
      key: "/view-file",
      private: true,
      element: <ViewFile />,
    },
  ];
}
